import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Dispatch, SetStateAction } from 'react';
import inMemoryJwt from '../core/services/inMemoryJwtService';
import { navigate } from 'gatsby';

const pages = ['Logout']
const authPages = ['Kings 19(Spain)', 'Corset 19(Spain)', 'Kings 20(Serbia)'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const style = {
    background: '#2E3B55'
};

interface NavbarProps {
    setIsUserLogged: Dispatch<SetStateAction<boolean>>
}
const Navbar = (props: NavbarProps) => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event: any) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: any) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const logoutHandler = (event: any) => {
        event.preventDefault();

        inMemoryJwt.deleteToken();        
        props.setIsUserLogged(false);
        navigate('/')
    };


    return (
        <AppBar position="static" style={{ background: "#C81528" }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
                    >
                        Kings
                    </Typography>

                   
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
                    >
                        LOGO
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={(e: any) => logoutHandler(e)}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>

                    
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default Navbar;
